import React from "react";
import { Link } from "react-router-dom";

const Footer = () => (
  <footer className="site-footer">
    <div className="site-shell footer-main">
      <div><img src="/logo.png" alt="Visiosol" className="footer-brand" /><p>AI agents, intelligent automation, trusted data, and software engineering for organizations ready to work smarter.</p></div>
      <div><h2>Explore</h2><a href="#ai-assistant">AI Assistant</a><a href="#services">Solutions</a><a href="https://fbrconnect.visiosol.tech">FBRConnect ↗</a><a href="#case-studies">Outcomes</a><a href="#contact">Contact</a></div>
      <div><h2>Contact</h2><a href="mailto:info@visiosol.tech">info@visiosol.tech</a><a href="tel:+923335274666">Call: +92 333 5274666</a><a href="https://wa.me/923335274666?text=Hello%20Visiosol%2C%20I%27d%20like%20to%20discuss%20a%20project%20with%20your%20team." target="_blank" rel="noreferrer">WhatsApp: +92 333 5274666</a></div>
    </div>
    <div className="site-shell footer-bottom"><span>© {new Date().getFullYear()} Visiosol. All rights reserved.</span><div><Link to="/privacy-policy">Privacy</Link><Link to="/terms-and-conditions">Terms</Link></div></div>
  </footer>
);
export default Footer;
